import * as Sentry from '@sentry/nextjs';
import { sendEvent } from '@/services/amplitude';

export const captureError = (error: any, tags: string[]) => {
  try {
    sendEvent('error-capture-event', {
      name: error?.name,
      type: tags[0],
      place: tags[1],
    });

    Sentry.withScope((scope) => {
      scope.setTag('error-type', tags[0]);
      scope.setTag('error-place', tags[1]);
      Sentry.captureException(error);
    });
    Sentry.captureException(error);
  } catch (e) {
    //
  }
};

export const captureMessage = (message: string, tags: string[]) => {
  try {
    sendEvent('error-message-event', {
      name: message,
      type: tags[0],
      place: tags[1],
    });

    Sentry.withScope((scope) => {
      scope.setTag('error-type', tags[0]);
      scope.setTag('error-place', tags[1]);
      Sentry.captureException(new Error(message));
    });
  } catch (e) {
    //
  }
};
